import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/actions`;

export interface SetFileActionCommandArgs {
  fileId: string;
  fromState?: string;
  toState?: string;
  module?: unknown;
  comment?: string;
  toCustomerComment?: string;
}

export const setFileActionRequest = (
  payload: SetFileActionCommandArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, payload.fileId),
  config: {
    method: SUPPORTED_METHODS.PUT,
    json: {
      fromState: payload.fromState,
      toState: payload.toState,
      module: payload.module,
      comment: payload.comment,
      toCustomerComment: payload.toCustomerComment,
    },
  },
});

const setFileActionCommand = async (
  payload: SetFileActionCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    return await executeQuery<BaseBackResponse>(setFileActionRequest(payload));
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default setFileActionCommand;
